<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="ah-detail-dialog declare-hint-dialog" append-to-body :before-close="onClose">
        <template slot="title"> 警告 </template>
        <div class="container">
            <div class="img-block">
                <img src="alertMark.jpg" alt="" />
            </div>
            <div class="text">已將 {{ count }} 筆加入{{ declarePeriodText }}申報清單</div>
            <div>
                <el-button type="primary" @click="onClose">知道了</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
    props: {
        visible: Boolean,
        count: Number,
    },
    computed: {
        ...mapState({
            declarePeriodText: (state) => {
                const PERIOD_OBJECT = _.find(
                    state.businessTax.periodList,
                    {
                        year: state.businessTax.declarePeriodYear,
                        value: state.businessTax.declarePeriod,
                    },
                );
                return PERIOD_OBJECT ? `${PERIOD_OBJECT.year - 1911}年 ${PERIOD_OBJECT.period}` : '--';
            },
        }),
    },
    methods: {
        onClose() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.declare-hint-dialog {
    display: flex;
    .container {
        padding: 20px;
        text-align: center;
    }
    .img-block {
        border: 1px solid #000;
        width: 70px;
        height: 70px;
        margin: auto;
    }
    .text {
        font-size: 16px;
        font-weight: bold;
        margin: 35px 0;
    }
    .el-dialog {
        width: 100%;
        max-width: 350px;
        margin: auto !important;
    }
}
</style>
